<template>
    <div class="papsi-wrapper flex justify-between">
        <div class="flex max-sm:flex-col max-sm:gap-3 justify-between w-full">
            <div>
                <h1 class="text-xl font-semibold text-[#24723b]" v-text="'Leave Form Request'"/>
                <p class="text-xs text-[#747474] mt-2" v-text="'Home / Form Requests / Leave Form Request'"/>
            </div>
            <div class="flex gap-3">
                <ButtonComponent 
                    class="w-[200px]"
                    :enabled="button == 1"
                    :name="'Leave Status'"
                    @click="button = 1"
                />
                <ButtonComponent 
                    class="w-[200px]"
                    :enabled="button == 2"
                    :name="'For Encoding'"
                    @click="button = 2"
                />
                <ButtonComponent 
                    class="w-[200px]"
                    :enabled="button == 3"
                    :name="'For Checking'"
                    @click="button = 3"
                />
                <button @click="getLeaveRequest" class="h-[50px] w-[50px] bg-[#CCAF12] flex border-[#a8a7a7] hover:bg-[#444] rounded-sm shadow-lg">
                    <img src="../../../assets/refresh.png" class="p-3">
                </button>
            </div>
        </div>
    </div>
    <div class="mt-6 w-full h-full flex flex-col gap-3">
        <div class="flex gap-3">
            <TextboxComponent 
                v-if="true"
                v-model="search"
                :labelname="'Search'" 
                class="w-[500px]"/>
            <ComboBoxComponent
                v-if="true"
                v-model="filter" 
                :labelname="'Filter'" 
                class="w-[250px]" 
                :data="combobox"/>
        </div>
        
        <div v-if="button === 1" class="h-[73vh]">
            <TableComponent 
                :header="header_name" 
                :column="column_name" 
                :data="leaveFilter" 
                :viewBtn="true"
                :select="false"
                @clickView="openLeaveModal" />
        </div>

        <div v-else class="h-[73vh]">
            <TableComponent 
                :header="header_name1" 
                :column="column_name1" 
                :data="leaveFilter" 
                :viewBtn="false"
                :select="false"
                :encode="button == 2"
                :check="button == 3"
                @encodeRequest="confirmValidation"/>
        </div>
    </div>

    <!-- LEAVE REQUEST MODAL VIEW DATA -->
    <LeaveRequestModal
        v-if="viewLeaveModal" 
            @close="viewLeaveModal = false"
            @encode="confirmValidation" 
            :activeBtn='activeBtn' 
            :data="leaveData"
            :apv="button!= 1"
       
        />
    <!-- PROMPT SUCCESSS ERROR -->
    <PromptComponent v-if="promptModal"
        :header="promptheader"
        :header1="promptheader1"
        :success="promptSuccess"
        @close="promptModal = false"/>

    <!-- VALIDATION PROMPT -->
    <ValidationComponent v-if="validation"
        :header="headerPrompt"
        @yes="confirmedValidation"
        @no="noValidation"/>

    <!-- MODAL -->
</template>
<script>
import ButtonComponent from '@/v1/components/ButtonComponent/ButtonComponent.vue';
import TableComponent from '@/v1/components/TableComponent/TableComponent.vue';
import LeaveRequest from '@/services/leaverequest';
import TextboxComponent from '@/v1/components/TextBoxComponent/TextboxComponent.vue';
import ComboBoxComponent from '@/v1/components/ComboBoxComponent/ComboBoxComponent.vue';
import LeaveRequestModal from '@/v1/modal/LeaveRequestModal.vue';
import PromptComponent from '@/v1/components/PromptComponents/PromptComponent.vue';
import ValidationComponent from '@/v1/components/PromptComponents/ValidationComponent.vue';

import { defineComponent } from 'vue';

export default defineComponent({
    components:{
        ButtonComponent,
        TableComponent,
        TextboxComponent,
        ComboBoxComponent,
        LeaveRequestModal,
        PromptComponent,
        ValidationComponent
    },
    data(){
        return{
            header_name:[
                'Date Filed',
                'Employee Name',
                'Date of Leave',
                'Duration',
                'Reason',
                'Status',
                'Action'
            ],
            column_name:[
                'submit_date',
               'employee_name',
               'leave_date',
               'duration',
               'reason',
               'status',
               'action' 
            ],
            header_name1:[
                'Date Filed',
                'Employee Name',
                'Date of Leave',
                'Duration',
                'Reason',
                'Action'
            ],
            column_name1:[
               'employee_name',
               'submit_date',
               'leave_date',
               'duration',
               'reason',
               'action' 
            ],
            combobox:[
                { key: "ALL", value: "ALL" },
                { key: "FOR RECOMMENDATION", value: "FOR RECOMMENDATION" },
                { key: "APPROVED", value: "APPROVED" },
                { key: "FOR APPROVAL", value: "FOR APPROVAL" },
                { key: "DISAPPROVED", value: "DISAPPROVED" },
                { key: "CANCELLED", value: "CANCELLED" },
            ],
            filter: 'ALL',
            leave_data: [],
            leave_filter: [],
            search: '',
            button: 1,
            viewLeaveModal: false,
            leaveData: [],
            validation: false,
            headerPrompt:null,
            leave_key: null,
            promptSuccess : false, 
            promptheader : null,    
            promptheader1 : null,     
            promptModal   : null,    
        }
    },
    computed: {
        leaveFilter() {
            
            const search = (this.search || "").toLowerCase();
            const filter = this.filter;
            const hasSearch = search.length > 0;
            const button = this.button

            return this.leave_filter.filter(e => {

                const name = (e.employee_name || "").toLowerCase();

                const matchSearch = !hasSearch || name.includes(search);

                const matchFilter =
                    !filter || filter === "ALL" || e.status === filter;
                
                let matchButton = true;
                if (button === 2) {
                    matchButton = e.status === "APPROVED" && e.encoded_datetime === null;
                } else if (button === 3) {
                    matchButton = e.status === "APPROVED" && e.encoded_datetime != null && e.checked_datetime === null;
                } 
                return matchSearch && matchFilter && matchButton;
            });
        }
    },
    mounted(){
        this.getLeaveRequest();
    },
    methods:{
         async getLeaveRequest(){
            let that = this
            this.$emit("showLoader")
            await LeaveRequest.searchLeaveRequest(that.search).then(function(response){
                that.leave_data   = response.data.data
                that.leave_filter = response.data.data
            }).catch(function(){
           
            });
            this.$emit("hideLoader")
        },
        openLeaveModal(data){
            //alert(JSON.stringify(data))
            this.leaveData = data
            this.viewLeaveModal = true
        },
        confirmValidation(leave_key)
        {
            this.leave_key = leave_key
       
            if(this.button === 2)
            {
                this.headerPrompt   = "Are you sure you want to encode this leave request?";
                this.validation     = true
            }
            else if(this.button === 3)
            {
                this.headerPrompt   = "Are you sure you want to check this leave request?";
                this.validation     = true
            }
        },
        confirmedValidation()
        {
            this.button === 2 ? this.encodeLeaveRequest(this.leave_key) : this.checkLeaveRequest(this.leave_key)
        },
        noValidation(){
            this.leave_key = null
            this.validation = false
        },
        async encodeLeaveRequest(leave_key){
            let that = this
            this.$emit("showLoader")
          
            await LeaveRequest.encodeLeaveRequest(leave_key).then(async function(){
                that.updateEncode(leave_key)
                that.viewLeaveModal  = false
                that.validation      = false
                that.promptSuccess   = true
                that.promptheader    = "Leave Record Successfully Encoded"
                that.promptheader1   = "The leave details have been saved and recorded in the system."
                that.promptModal     =  true
            }).catch(function(error){
                that.promptSuccess   = false
                that.promptheader    = "ERROR"
                that.promptheader1   = error.response.data.message
                that.promptModal     = true
            });
            this.$emit("hideLoader")
        },
        async checkLeaveRequest(leave_key){
            let that = this
            this.$emit("showLoader")
            await LeaveRequest.checkLeaveRequest(leave_key).then(async function(){
                that.updateCheck(leave_key)
                that.viewLeaveModal  = false
                that.validation      = false
                that.promptSuccess   = true
                that.promptheader    = "Leave Record Already Verified"
                that.promptheader1   = "This leave record has been validated and no further action is required."
                that.promptModal     =  true
            }).catch(function(error){
                that.promptSuccess   = false
                that.promptheader    = "ERROR"
                that.promptheader1   = error.response.data.message
                that.promptModal     = true
            });
            this.$emit("hideLoader")
        },
        updateEncode(ref_no)
        {
            const record = this.leave_filter.find(e => e.ref_no === ref_no);
            if (record) {
                record.encoded_datetime = new Date();
                record.encoded_emp_key = this.$store.state.employee_key
            }
        },
        updateCheck(ref_no)
        {
            const record = this.leave_filter.find(e => e.ref_no === ref_no);
            if (record) {
                record.checked_datetime = new Date();
                record.checked_emp_key = this.$store.state.employee_key
            }
        }
    }
})

</script>